import addressesService from "@/services/addressesService";

const state = () => ({
});

const actions = {
  async findCity({ dispatch }, formData) {
    try {
      const res = await addressesService.findCity(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Stadt konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
